Ext.define('SA.ProjectController', {
    extend: 'SA.ViewController',

    constructor() {
        this.callParent(arguments);
    },

    createDefaultView() {
        return SA.ProjectView.createHidden({
            xtype: 'project-settings',
            projectView: this.model,
            listeners: {'toggle:historicalViews': this.onToggleHistoricalViews, scope: this}
        });
    },

    createEditView() {
        return SA.ProjectView.createHidden({
            xtype: 'new-view',
            countryCode: this.model.getCountry(),
            countryModel: this.model.getCountryModel(),
            listeners: {'click:createView': this.onClickCreateView, scope: this}
        });
    },

    onActive() {
        SA.Sidebar.showMask();
        SA.Sidebar.hideToolbarTabs();

        if (!SA.Sidebar.hasSelectedTab()) {
            SA.Sidebar.setEnabledTabs(['locations', 'data', 'businesses']);
            SA.Sidebar.setSelectedTab('data');
        }
    },

    onClickCreateView({type, censusRelease}) {
        var view = this.model.addViewWithParams({type, params: {censusRelease}});

        if (type === 'locationQuery') {
            SA.AppController.showProjectView(view);
            return;
        }

        SA.AppController.showProjectView(view, 'edit');
    },

    onToggleHistoricalViews(enabled) {
        this.model.setHistoricalViewsCreationEnabled(enabled);
        this.model.save();
    },

    showView() {
        this.callParent(arguments);

        if (this.isEditMode()) {
            let view = this.projectViews.getEditModeItem(),
                hasNoViews = this.model.getViews().length === 0;

            view.setHistoricalViewsEnabled(this.model.isHistoricalViewsCreationEnabled());
            view.setNoViewsMessageVisible(hasNoViews);
        }
    }
});